module.exports = "<driver-score-graph [score]=driverScore [width]=250></driver-score-graph>";